import ODropDownMenu from '../DropDownMenu/ODropDownMenu';

function MeetingOptions({ children }) {
  const meetingOptions = [
    {
      id: 1,
      title: 'Izmeni',
      icon: 'fas fa-edit',
      color: '#111827',
      iconSize: '15px',
      onClick: () => {},
    },
    {
      id: 2,
      title: 'Obriši',
      icon: 'fas fa-trash',
      color: '#ef4444',
      iconSize: '15px',
      onClick: () => {},
    },
  ];

  return <ODropDownMenu options={meetingOptions}>{children}</ODropDownMenu>;
}

export default MeetingOptions;
